module.exports = __webpack_public_path__ + "img/sendmsg.30b23872.svg";